import { NamedObjectDisplay } from "./NamedObjectDisplay";
import { RemoveArsItemButton } from "./RemoveArsItemButton";
import { WhereClauseManager } from "./WhereClauseManager";

/**
 * Props for the GroupControl component.
 */
export interface GroupControlProps {
  /** RFC 6901 JSON Pointer path to the Group in ARSContext state */
  dataPath: string;
}

/**
 * A component for managing Group entities with full CRUD capabilities.
 *
 * This component provides:
 * - NamedObjectDisplay for editing name, description, and label
 * - WhereClauseManager for managing where clause conditions
 * - RemoveButton for deleting the group
 *
 * @param props - Component props.
 * @param props.dataPath - RFC 6901 JSON Pointer path to the Group in ARSContext state.
 * @returns A React functional component rendering the group editor.
 */
export const GroupControl = ({ dataPath }: GroupControlProps): React.ReactElement => {
  return (
    <div className="border rounded p-3 mb-3 position-relative">
      <div className="position-absolute top-0 end-0 m-2">
        <RemoveArsItemButton dataPath={dataPath} />
      </div>

      <NamedObjectDisplay
        dataPath={dataPath}
        canRename
      />

      <WhereClauseManager dataPath={dataPath} />
    </div>
  );
};

GroupControl.displayName = "GroupControl";
